import { Breadcrumb, Button, Card, Col, Empty, Form, Input, message, Row, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import FormItem from 'antd/lib/form/FormItem';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component, FormEvent } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';

import { CouponTemplate, CouponTemplateStatus, CouponTemplateStatusText } from '../../types/coupon';

export const COUPON_TEMPLATE_QUERY = gql`
  query GetCouponTemplate($ids: [ID], $name: String) {
    couponTemplates(ids: $ids, name: $name) {
      id
      name
      type
      amount
      description
      status
      validDuration
    }
  }
`;

interface Props {
  match: any;
  form: WrappedFormUtils;
}

interface State {
  variables: {
    ids?: string[];
    name?: string;
  };
}

export class CouponListForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { variables: {} };

    this.search = this.search.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
  }

  onResetClick() {
    this.props.form.resetFields();
  }

  componentDidMount() {
    this.props.form.validateFields();
  }
  search(e: FormEvent) {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }

      this.setState({
        variables: {
          ids: Number(values.couponTemplateId) ? [values.couponTemplateId] : undefined,
          name: values.couponTemplateName,
        },
      });
    });
  }

  render() {
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>优惠券管理</Breadcrumb.Item>
        </Breadcrumb>
        <Query query={COUPON_TEMPLATE_QUERY} variables={this.state.variables}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const { couponTemplates = [] } = data || {};
            const { getFieldDecorator } = this.props.form;
            return (
              <Card>
                <Form onSubmit={this.search}>
                  <Row gutter={24}>
                    <Col xs={24} md={24} lg={24} xl={8} xxl={8}>
                      <FormItem label={`ID`}>
                        {getFieldDecorator('couponTemplateId')(<Input placeholder="请输入优惠券ID" allowClear />)}
                      </FormItem>
                    </Col>
                    <Col xs={24} md={24} lg={24} xl={8} xxl={8}>
                      <FormItem label={`名称`}>
                        {getFieldDecorator('couponTemplateName')(<Input placeholder="请输入优惠券名称" allowClear />)}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row type="flex" justify="end">
                    <Button icon="search" type="primary" style={{ marginRight: 8 }} htmlType="submit">
                      搜索
                    </Button>
                    <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                      重置
                    </Button>
                  </Row>
                </Form>
                <Table<CouponTemplate>
                  dataSource={couponTemplates.filter(tempalte => tempalte.status === CouponTemplateStatus.ACTIVE)}
                  loading={loading}
                  pagination={false}
                  rowKey={row => `${row.id}`}
                >
                  <Table.Column dataIndex="id" title="ID" key="id" />
                  <Table.Column dataIndex="name" title="名称" key="name" />
                  <Table.Column dataIndex="description" title="简介" key="description" />
                  <Table.Column
                    dataIndex="status"
                    title="状态"
                    render={status => CouponTemplateStatusText[status]}
                    key="status"
                  />
                  <Table.Column
                    dataIndex="validDuration"
                    key="validDuration"
                    title="有效期"
                    render={validDuration => `领取${moment.duration(validDuration, 'hours').humanize()}内有效`}
                  />
                  <Table.Column
                    dataIndex="id"
                    key="actions"
                    title="查看详情"
                    render={id => <Link to={`/coupon/${id}`}>详情</Link>}
                  />
                </Table>
              </Card>
            );
          }}
        </Query>
      </>
    );
  }
}

export const CouponList = Form.create({ name: 'CouponList' })(CouponListForm);



// WEBPACK FOOTER //
// ./src/screens/coupon/CouponList.tsx